export enum SPACING_MODES {
    NORMAL = 'normal',
    LARGE = 'large',
}

export interface ProOverviewProps {
    className?: string;
    spacingMode?: SPACING_MODES;
}
